'use client'

import LeftSide from './LeftSide'
import RightSide from './RightSide'
import RightSideMobile from './RightSideMobile'
import { HeaderLogo } from '@shared/layouts/navigation/HeaderLogo'
import { usePathname } from 'next/navigation'

const Nav = (): React.JSX.Element => {
  const pathname = usePathname()
  const hideGlobalNav =
    pathname?.startsWith('/dashboard') ||
    // The volunteer shell (ENG-11052) draws its own top bar — logo, org
    // picker, profile dropdown — same reasoning as /dashboard.
    pathname?.startsWith('/volunteer') ||
    pathname?.startsWith('/onboarding') ||
    // The elected-official ("serve") flow is a focused, full-screen experience
    // with its own logo + stepper chrome (mirroring /onboarding), so the global
    // marketing nav is suppressed here too — pairs with isProductRoute, which
    // already hides the global footer on /serve.
    pathname?.startsWith('/serve') ||
    // One-time sign-in link redemption: same focused chrome as /serve/welcome,
    // and showing a marketing "Login" link to someone mid-sign-in is worse than
    // useless.
    pathname?.startsWith('/sign-in-link') ||
    // Unsubscribe and reply-address pages opened from outreach email: a card
    // with its own wordmark, and no marketing nav for a one-click action.
    pathname?.startsWith('/email') ||
    // Dev-only surfaces (e.g. the /dev/briefings gallery) reuse dashboard
    // chrome and should not show the marketing nav.
    pathname?.startsWith('/dev')

  return (
    <>
      <div
        id="top-nav"
        className={`fixed w-screen h-14 z-50${hideGlobalNav ? ' hidden' : ''}`}
      >
        <div className="relative bg-indigo-50 lg:block border-solid border-b border-zinc-200 px-5 lg:px-8 z-50 h-14">
          <div
            className="flex justify-between items-center h-14"
            data-testid="navbar"
          >
            <div className="flex items-center">
              <HeaderLogo />

              {!hideGlobalNav && <LeftSide />}
            </div>
            {!hideGlobalNav && <RightSide />}
          </div>
        </div>
      </div>
      {!hideGlobalNav && <RightSideMobile />}
      <div
        id="top-nav-spacer"
        className={`h-14 relative${hideGlobalNav ? ' hidden' : ''}`}
      >
        &nbsp;
      </div>
    </>
  )
}

export default Nav
